package com.example.mystybag.sharedmodels.project.responseModels.nomenclatures

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class GetCategoryKeywordsResponseModel(
    val keywords: List<CategoryKeywordModel> = emptyList()
) : BaseResponseModel()

@Serializable
data class CategoryKeywordModel(
    val businessCategoryId: Long,
    val keywords: String // Comma-separated keywords
)
